<template>
  <component
    :is="component"
    class="bg-action-default-mid text-action-default-hi rounded-full body-2 flex h-36 w-fit max-w-full shrink-0 items-center px-12"
    :class="{
      'hover:bg-action-default-mid-hover': isInteractive,
      'bg-action-default-low border-static-success-hi text-action-success-hi body-2-bold border hover:bg-action-success-min-hover':
        isActive,
    }"
    target="blank"
  >
    <div v-if="$slots.prefix" class="mr-8 shrink-0">
      <slot name="prefix" />
    </div>

    <p
      class="line-clamp-1 overflow-hidden text-ellipsis text-left md:overflow-auto md:text-clip"
    >
      {{ label }}
    </p>

    <IconChevronRight v-if="isInteractive && !suffixIcon" class="shrink-0" />
    <component
      :is="suffixIcon"
      v-if="suffixIcon"
      class="ml-5 h-20 w-20 shrink-0"
    />
  </component>
</template>

<script lang="ts" setup>
import { type Component, computed, useAttrs } from 'vue'

import { RevButtonBase } from '@ds/components/ButtonBase'
import { IconChevronRight } from '@ds/icons/IconChevronRight'

defineProps<{
  isActive?: boolean
  label: string
  suffixIcon?: Component
}>()

const attrs = useAttrs()

const isInteractive = computed(() => attrs.onClick)
const hasLink = computed(() => attrs.to)

const component = computed(() => {
  if (isInteractive.value || hasLink.value) {
    return RevButtonBase
  }

  return 'div'
})
</script>
